export default {
  auth: '/api/v1/identity/login',
  logout: '/api/v1/identity/logout',
  emailVerification: '/api/v1/identity/verify',
  accountActivation: '/api/v1/identity/activate',
  ownUserInfo: '/api/v1/identity/whoami',
  editAccount: '/api/v1/identity/users/',
  getVehicle: '/api/v1/orders/contracts/vehicles',
  getLocationOrigin: '/api/v1/orders/contracts/locations/origin',
  getLocationDestination: '/api/v1/orders/contracts/locations/destination',
  getListShipment: '/api/v1/orders/shipments/filter',
  getShipment: `/api/v1/orders/shipments`,
  createShipment: '/api/v1/orders/shipments',
  createContinueShipment: '/api/v1/orders/shipments/continues',
  getInfo: '/api/v1/orders/selection-info/filter',
  getCategory: '/api/v1/orders/categories/filter',
  getVehicleById: '/api/v1/orders/transport-types',
  getSubCategory: (idCategories) => `/api/v1/orders/categories/${idCategories}/sub`,
  getStatusHistory: (idShipment) => `/api/v1/delivery/shipments/${idShipment}/status-history`,
  getDocument: (idShipment, type) => `/api/v1/orders/shipments/${idShipment}/document/${type}`,
  podDocument: '/api/v1/orders/shipments/action/pod',
  cancelShipment: '/api/v1/orders/shipments/action/cancel',
  postRating: '/api/v1/orders/shipments/action/rate',
  uploadImage: '/api/v1/image-upload',
  getLastLocations: (idShipment) => `/api/v1/delivery/shipments/${idShipment}/positions`,
  changePassword: '/api/v1/identity/change-password',
  getListUser: '/api/v1/identity/users/filter',
  userDetail: '/api/v1/identity/users',
  userResetPassword: '/api/v1/identity/users/reset',
  userList: '/api/v1/identity/users/filter',
  userActivation: '/api/v1/identity/users/active-deactive',
  notification: '/api/v1/identity/notifications',
  notificationList: '/api/v1/identity/notifications/filter',
  notificationUnreadCount: '/api/v1/identity/notifications/counter',
  getUnAssignShipment: '/api/v1/orders/shipments/unassigned',
  shipperConfirm: '/api/v1/orders/shipments/shipper/confirm',
  getCostEstimationReport: '/api/v1/transaction/report/invoice/income/shipper',
  getAgingReport: '/api/v1/transaction/report/invoice/aging/shipper',
  getOrderSummary: '/api/v1/orders/shipments/summary',
  getOrderShipperReport: 'api/v1/orders/report/shipment/shipper',
  getListBasp: '/api/v1/orders/report/basp/shipper',
  getDamageShipment: 'api/v1/orders/shipments/damage/detail'

}
